import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/talent',
    authDomain: 'authenticate.staging.seek.com',
    clientDomain: 'id.employer.staging.seek.com',
    clientId: 'kfBakzmlw9xX4yGBmqVBQhrRGIGtRi4N',
    environment: 'dev',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    contactUs: {
        en: 'https://jobstreet-about.kinsta.seekasia.com/about-us/contact-us-indonesia/',
        id: 'https://www.jobstreet.com/about-us/id-id/hubungi-kami-di-indonesia/',
    },
    siteName: siteNames.employer.seek.id,
    zone: getZoneFromSite(siteNames.employer.seek.id),
    brand: Brand.SEEK,
    product: Product.HIRER,
};
//# sourceMappingURL=id_employer_staging_seek_com.js.map